import type { DocumentNode, OperationDefinitionNode } from 'graphql'

/** Name of the first named operation in the document, or null — Apollo Client 3's `getOperationName` contract. */
export const getOperationName = (doc: DocumentNode): string | null =>
  doc.definitions.find((d): d is OperationDefinitionNode => d.kind === 'OperationDefinition' && !!d.name)?.name
    ?.value ?? null
